import { GenerateProjectOptions, generateProjectObject } from '../projects';
import { ThreadProject } from './thread-projects.model';

export type GenerateThreadProjectOptions = GenerateProjectOptions;

/**
 * Returns a thread project object.
 */
export function generateThreadProjectObject(
  args: GenerateThreadProjectOptions,
): ThreadProject {
  return {
    ...generateProjectObject(args),
    skills: [],
  };
}
